// extracted by mini-css-extract-plugin
module.exports = {"container":"src-components-AppHistory-Preview-AppInformation-AppInformation-module__container--1e4ye"};